import { useEffect, useState } from "react";
import { europeanCountries } from "@/constant/european-countries";
import { DEBUGGER } from "@/helper/helper";
import { cookiePersistStorage } from "@/helper/common.helper";

export const useConsentMode = () => {
  const [isEuropeanUser, setIsEuropeanUser] = useState(false);

  const getConsentMode = (): Record<string, string> | null => {
    try {
      const storedConsent = localStorage?.getItem("consentMode");
      return storedConsent ? JSON.parse(storedConsent) : null;
    } catch (error) {
      DEBUGGER("Failed to parse consentMode from localStorage", error);
      return null;
    }
  };

  const updateConsentMode = (
    consentMode: Record<string, string | boolean>,
    type: "default" | "update",
  ) => {
    try {
      localStorage.setItem("consentMode", JSON.stringify(consentMode));
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "consentModeUpdate", ...consentMode });
      if (window.gtag) {
        window.gtag("consent", type, consentMode);
      }
    } catch (error) {
      DEBUGGER("Failed to update consentMode", error);
    }
  };

  useEffect(() => {
    const initializeConsentMode = () => {
      const countryCode = cookiePersistStorage.getItem("cf-ipcountry");
      const isEuropean = countryCode && europeanCountries.includes(countryCode);
      setIsEuropeanUser(Boolean(isEuropean));
    };

    initializeConsentMode();
  }, []);

  return { isEuropeanUser, getConsentMode, updateConsentMode };
};
